'use client';
import { dynamicDateTimeStringWithTz } from '@mnd-frontend/dates';
import { GREY_700, SIZING_1_5 } from '@mnd-frontend/ui/shared/tokens';
import { useEffect, useState } from 'react';
import styled from 'styled-components';

const Time = styled.time<{ $compact: boolean }>`
  color: ${GREY_700};
  font-weight: 500;
  font-size: ${props => (props.$compact ? SIZING_1_5 : '0.875rem')};
  line-height: 1.25;
`;

type LiveTimeProps = {
  date: string | Date;
  timezone: string;
  locale: string;
  updateIntervalMs?: number;
  compact?: boolean;
};

const LiveTime = ({
  date,
  timezone,
  locale,
  updateIntervalMs = 10000,
  compact = false,
}: LiveTimeProps) => {
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => {
      setNow(new Date());
    }, updateIntervalMs);

    return () => clearInterval(interval);
  }, [updateIntervalMs]);

  return <Time $compact={compact}>{dynamicDateTimeStringWithTz(date, timezone, locale, now)}</Time>;
};

export default LiveTime;
